import React, { useEffect } from 'react';
import { Default as Alert } from '@gjensidige/core-alerts';
import { CriticalButton } from '@gjensidige/core-buttons';
import { useFetch } from '@gjensidige/gpf-react-components';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { text } from '../../../utils/text';
import { getSignResult } from '../../../utils/api';
import { Action } from '../../../utils/types';
import { scenarioSteps, trackScenario } from '../../../tracking';
import { Layout } from '../../common/Layout/Layout';
import utils from '@gjensidige/core-utilities-css';
import { Card } from '../../common/Card/Card';
import { useGlobalDispatch, useGlobalState } from '../../../context/GlobalContext';
import { SpinnerRow } from '../../common/SpinnerRow/SpinnerRow';
import { Text } from '@gjensidige/core-typography';
export const DocumentSignedPageRedirect = () => {
    const { signingParams } = useGlobalState();
    const history = useHistory();
    if (!signingParams) {
        return (React.createElement(Layout, { size: 'small', title: 'Noe gikk galt' },
            React.createElement("div", { className: "flex-column" },
                React.createElement(Alert, { alertType: "error", title: text.DOCUMENT_SIGNED_PAGE.ERROR.MISSING_REQUEST_ID.no }),
                React.createElement(CriticalButton, { className: utils['mt-2'], type: "button", onClick: () => history.push(`/avtale`) }, text.DOCUMENT_SIGNED_PAGE.ERROR.TRY_AGAIN.no))));
    }
    return React.createElement(Redirect, { to: `/signed/${signingParams === null || signingParams === void 0 ? void 0 : signingParams.requestId}` });
};
export const DocumentSignedPage = () => {
    var _a, _b;
    const { requestId } = useParams();
    const dispatch = useGlobalDispatch();
    const history = useHistory();
    const [isFetching, signResult, error] = useFetch({
        promise: () => getSignResult(requestId),
        deps: [requestId],
    });
    useEffect(() => {
        if ((signResult === null || signResult === void 0 ? void 0 : signResult.status) && (signResult === null || signResult === void 0 ? void 0 : signResult.status.success)) {
            trackScenario(scenarioSteps.SIGNING_COMPLETE);
        }
    }, [signResult]);
    useEffect(() => {
        signResult &&
            dispatch({
                type: Action.UPDATE_SIGN_RESULT,
                signResult: signResult,
            });
    }, [dispatch, signResult]);
    if (isFetching) {
        return (React.createElement(Layout, { size: 'small', title: text.DOCUMENT_SIGNED_PAGE.FETCHING.HEADER.no, subtitle: text.DOCUMENT_SIGNED_PAGE.FETCHING.PLEASE_WAIT.no },
            React.createElement(SpinnerRow, { spinnerSize: 70 })));
    }
    if (((_a = signResult === null || signResult === void 0 ? void 0 : signResult.status) === null || _a === void 0 ? void 0 : _a.status) === 'signed-but-failed-to-create-policy') {
        return (React.createElement(Layout, { size: 'normal', title: 'Spareavtale er signert' },
            React.createElement(Card, { title: 'Start sparingen', subtitle: text.DOCUMENT_SIGNED_PAGE.ERROR.SIGNERT_MEN_IKKE_OPPRETTET.no })));
    }
    if (error || !signResult || !((_b = signResult.status) === null || _b === void 0 ? void 0 : _b.success)) {
        return (React.createElement(Layout, { size: 'small', title: text.DOCUMENT_SIGNED_PAGE.ERROR.HEADER.no },
            React.createElement("div", { className: "flex-column" },
                React.createElement("div", { className: 'padding-bottom' },
                    React.createElement(Text, null, text.DOCUMENT_SIGNED_PAGE.ERROR.VELKOMMEN_TILBAKE.no)),
                React.createElement(CriticalButton, { className: utils['mt-2'], type: "button", onClick: () => history.push(`/signing/${requestId}`) }, text.DOCUMENT_SIGNED_PAGE.ERROR.TRY_AGAIN.no))));
    }
    return React.createElement(Redirect, { to: `/start-sparing/${requestId}` });
};
